export const LetterheadDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" />
        <path
            d="M20.7058 16.5522V9.8824C20.7058 9.3626 20.2845 8.94122 19.7646 8.94122H12.2352C11.7154 8.94122 11.2941 9.3626 11.2941 9.8824V16.5522"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.8252 15.6644C21.9665 15.5522 22.1596 15.5309 22.3222 15.6093C22.4847 15.6877 22.588 15.8522 22.5882 16.0326V22.1189C22.5882 22.6387 22.1669 23.0601 21.647 23.0601H10.3529C9.8331 23.0601 9.41172 22.6387 9.41172 22.1189V16.0326C9.41188 15.8522 9.51522 15.6877 9.67773 15.6093C9.84024 15.5309 10.0333 15.5522 10.1747 15.6644L14.8373 19.3625C15.5197 19.8985 16.4801 19.8985 17.1626 19.3625L21.8252 15.6644Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8628 13.0197H14.4314"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8628 14.2744H16.1569"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.8654 10.8234H17.3698C17.3063 10.8234 17.2548 10.8749 17.2548 10.9385V12.4339C17.2548 12.4974 17.3063 12.5489 17.3698 12.5489H18.8654C18.9289 12.5489 18.9803 12.4974 18.9803 12.4339V10.9385C18.9803 10.8749 18.9289 10.8234 18.8654 10.8234Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
